import { defineComponent as _defineComponent } from 'vue'
import ViewLevelWrapper from '@/views/Automation/CampaignCreatorV2/components/ViewLevel/ViewLevelWrapper.ts.vue';
import CcPreview from '@/views/Automation/CampaignCreatorV2/preview/CcPreview.ts.vue';
import AdSetTab from '@/views/Automation/CampaignCreatorV2/steps/AdSetTab.ts.vue';
import AdTab from '@/views/Automation/CampaignCreatorV2/steps/AdTab.ts.vue';
import CampaignTab from '@/views/Automation/CampaignCreatorV2/steps/CampaignTab.ts.vue';
import useAdStore from '@/views/Automation/CampaignCreatorV2/store/Ad';
import useAdAccountStore from '@/views/Automation/CampaignCreatorV2/store/AdAccount';
import useCampaignStore from '@/views/Automation/CampaignCreatorV2/store/Campaign';
import useNavigationStore from '@/views/Automation/CampaignCreatorV2/store/Navigation';
import { addImageEditorScript } from '@sh/helpers';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateCampaign.ts',
  setup(__props) {

/* eslint-disable import/no-cycle */
const campaignStore = useCampaignStore();
const adAccountStore = useAdAccountStore();
const navigationStore = useNavigationStore();
const adStore = useAdStore();

campaignStore.$onAction(
  ({
    name, // name of the action
    store, // store instance, same as `someStore`
    args, // array of parameters passed to the action
    after, // hook after the action returns or resolves
    onError, // hook if the action throws or rejects
  }) => {
    // a shared variable for this specific action call
    const startTime = Date.now();

    // this will trigger if the action throws or returns a promise that rejects
    onError((error) => {
      console.warn(`Failed "${name}" after ${Date.now() - startTime}ms.\nError: ${error}.`);
    });
  }
);

const activeTab = computed(() => navigationStore.currentLevel);
const isTransition = computed(() => navigationStore.isTransition);

try {
  addImageEditorScript();
  campaignStore.fetchTemplates();
  adAccountStore.fetchAdAccounts();
  adStore.getSuggestedVariables();
  if (!Object.values(campaignStore.campaigns).length) {
    campaignStore.addNewCampaign();
  }
} catch (error) {
  console.error('Error while creating empty campaign', error);
}

return { __sfc: true,campaignStore, adAccountStore, navigationStore, adStore, activeTab, isTransition, ViewLevelWrapper, CcPreview, AdSetTab, AdTab, CampaignTab }
}

})